export const PAGO_COBROS_REQUEST = 'PAGO_COBROS_REQUEST';
export const PAGO_COBROS_SUCCESS = 'PAGO_COBROS_SUCCESS';
export const PAGO_COBROS_ERROR   = 'PAGO_COBROS_ERROR';
export const PAGO_COBROS_RESET   = 'PAGO_COBROS_RESET';
